/* AUTOGENERERAD — kör `bun run gen:links`. Ändra inte för hand.
 *
 * Kompakt katalog över publika sidor: [sökväg, ankartext, kluster].
 * Används av src/lib/seo/linkGraph.ts för att ge varje sida kontextuella
 * länkar in och ut, oberoende av meny och sidfot.
 */

export type CatalogEntry = readonly [path: string, anchor: string, cluster: string];

export const PAGE_CATALOG: readonly CatalogEntry[] = [
  ["/", "Film som bygger varumärke, driver leads och", "hub"],
  ["/3d-animation", "3D-animation när verkligheten inte räcker som", "tjanster"],
  ["/3d-produktvisualisering", "Produktvisualisering i 3D", "tjanster"],
  ["/aftermovie", "Aftermovie som faktiskt får folk att vilja vara med", "tjanster"],
  ["/animation/goteborg", "Animation i Göteborg", "lokalt"],
  ["/animation/malmo", "Animation i Malmö", "lokalt"],
  ["/animation/stockholm", "Animation i Stockholm", "lokalt"],
  ["/animerad-forklaringsfilm", "Animerad förklaringsfilm som faktiskt förklarar", "tjanster"],
  ["/animerad-reklamfilm", "Animerad reklamfilm som förklarar det abstrakta", "tjanster"],
  ["/b-roll-inspelning", "B-roll som gör torr berättelse levande", "tjanster"],
  ["/b2b-video", "B2B-video som kortar säljcykeln", "tjanster"],
  ["/branscher/bygg", "Film för byggbranschen", "branscher"],
  ["/branscher/e-handel", "Filmproduktion för e-handel som faktiskt skalar", "branscher"],
  ["/branscher/fastighet", "Film för fastighetsbolag", "branscher"],
  ["/branscher/halsa", "Film för medtech och hälsa", "branscher"],
  ["/branscher/industri", "Filmproduktion för industri och tillverkning", "branscher"],
  ["/branscher/offentlig-sektor", "Filmproduktion för offentlig sektor", "branscher"],
  ["/branscher/restaurang", "Film för restaurang och hotell", "branscher"],
  ["/branscher/saas", "Filmproduktion för SaaS som driver pipeline", "branscher"],
  ["/branscher/video-for-b2b", "B2B-video som driver pipeline", "branscher"],
  ["/branscher/video-for-marknadsavdelningar", "Ett löpande filmflöde mot er innehållskalender", "branscher"],
  ["/branscher/video-for-saljteam", "Film som förkortar säljcykeln", "branscher"],
  ["/branscher/video-for-tillvaxtbolag", "Film som skalar i takt med bolaget", "branscher"],
  ["/branschstudier", "Branschstudier", "tjanster"],
  ["/branschstudier/bildindex-2026", "Fotografering 2026", "tjanster"],
  ["/branschstudier/filmproduktionsbarometern", "Filmproduktionsbarometern 2026", "tjanster"],
  ["/branschstudier/formatbenchmark-2026", "Formatbenchmark filmproduktion Sverige 2026", "tjanster"],
  ["/branschstudier/prisindex-2026", "Prisindex filmproduktion Sverige 2026", "tjanster"],
  ["/branschstudier/produktfilm", "Produktfilm i Sverige 2026", "tjanster"],
  ["/brollopsfilm", "Bröllopsfilm i samma hantverk som varumärken", "tjanster"],
  ["/case", "Arbeten som levererar resultat", "case"],
  ["/case/arets-pryl-2026", "Årets Pryl 2026", "case"],
  ["/case/bolt-20-sekunder", "Bolt", "case"],
  ["/case/garageportexperten-30-ar", "30 år med Garageportexperten", "case"],
  ["/case/garageportexperten-hemma", "Garageportexperten Hemma", "case"],
  ["/case/huawei-also-energy", "Huawei Energy Solution in Denmark", "case"],
  ["/case/wimeck-detailing", "Wimeck Detailing", "case"],
  ["/casting-skadespelare", "Casting där rollen får bära filmen", "tjanster"],
  ["/dokumentarfilm", "Dokumentärfilm där människor får säga det ni inte", "tjanster"],
  ["/dronarfilm", "Drönarfilm", "tjanster"],
  ["/employer-branding-film", "Employer branding-film som faktiskt påverkar", "tjanster"],
  ["/employer-branding-film/goteborg", "Employer branding-film i Göteborg som faktiskt", "tjanster"],
  ["/employer-branding-film/malmo", "Employer branding-film i Malmö som faktiskt", "tjanster"],
  ["/employer-branding-film/stockholm", "Employer branding-film i Stockholm som faktiskt", "tjanster"],
  ["/en", "Video that drives the business, in the rhythm of", "en"],
  ["/en/3d-animation", "Show what a camera never could", "en"],
  ["/en/about", "We make video for people", "en"],
  ["/en/ad-agency", "Ads that earn attention and move numbers", "en"],
  ["/en/aftermovie", "Sell next year&#x27;s tickets with this year&#x27;s", "en"],
  ["/en/agency-vs-freelancer", "Freelancer or film agency", "en"],
  ["/en/b-roll", "Build the footage library your team keeps reaching", "en"],
  ["/en/brand-film", "The anthem your brand keeps coming back to", "en"],
  ["/en/campaign-film", "One shoot", "en"],
  ["/en/commercials", "Commercials people actually watch", "en"],
  ["/en/contact", "Let&#x27;s make your next video together", "en"],
  ["/en/content-agency", "Editorial-grade content", "en"],
  ["/en/corporate-video", "Company films without the boardroom feel", "en"],
  ["/en/customer-story-video", "Your best salesperson is already a customer", "en"],
  ["/en/documentary", "True stories, told with cinematic care", "en"],
  ["/en/employer-branding-video", "Show why people stay", "en"],
  ["/en/event-film", "Turn one event into a year of marketing", "en"],
  ["/en/faq", "Answers to what you usually ask", "en"],
  ["/en/film-agency", "An agency that owns the creative and the camera", "en"],
  ["/en/film-producer", "A senior producer on every project", "en"],
  ["/en/film-production", "Full-service film production, end to end", "en"],
  ["/en/film-production-sweden", "Film production in Sweden", "en"],
  ["/en/for-journalists", "Sources, data and same-day comments", "en"],
  ["/en/glossary", "Video production, in plain English", "en"],
  ["/en/heritage", "Stories and knowledge that should not be lost", "en"],
  ["/en/heritage/kunskapsarv", "Knowledge Legacy", "en"],
  ["/en/heritage/livsberattelse-till-foralder", "A filmed life story for a parent or grandparent", "en"],
  ["/en/heritage/livsberattelser", "Filmed Life Stories", "en"],
  ["/en/heritage/minnesfilm", "Memorial film for a milestone, anniversary or", "en"],
  ["/en/heritage/pensionsavgang-kunskapsoverforing", "Knowledge transfer before a key person retires", "en"],
  ["/en/heritage/tyst-kunskap-dokumentation", "Documenting tacit knowledge on film", "en"],
  ["/en/how-long-should-a-commercial-be", "How long should your commercial be", "en"],
  ["/en/image-film", "The film that introduces you to the world", "en"],
  ["/en/industries/construction", "Video for construction", "en"],
  ["/en/industries/ecommerce", "Video that earns the click and the second view", "en"],
  ["/en/industries/health", "Video for healthcare", "en"],
  ["/en/industries/industry", "Video for industry", "en"],
  ["/en/industries/public-sector", "Video for the public sector", "en"],
  ["/en/industries/real-estate", "Video for property", "en"],
  ["/en/industries/restaurant", "Video that makes guests book before they read the", "en"],
  ["/en/industries/saas", "Video that shortens the SaaS sales cycle", "en"],
  ["/en/inhouse-vs-agency", "In-house team or film agency", "en"],
  ["/en/instructional-video", "Show, don&#x27;t tell", "en"],
  ["/en/internal-communication-video", "Talk to the whole company without sending another", "en"],
  ["/en/knowledge", "We write about what we do", "en"],
  ["/en/live-streaming", "Broadcast-grade live, without the broadcast headache", "en"],
  ["/en/motion-graphics", "Make the abstract feel obvious", "en"],
  ["/en/partners", "We&#x27;d rather grow with the right partners than", "en"],
  ["/en/photography", "Corporate photography for companies in Sweden", "en"],
  ["/en/photography/corporate-portraits", "Corporate portraits and headshots", "en"],
  ["/en/photography/event-photography", "Event photography for conferences and corporate", "en"],
  ["/en/photography/gothenburg", "English-speaking corporate photographer in", "en"],
  ["/en/photography/malmo", "English-speaking corporate photographer in Malmö", "en"],
  ["/en/photography/product-photography", "Product photography for e-commerce and campaigns", "en"],
  ["/en/photography/stockholm", "English-speaking corporate photographer in Stockholm", "en"],
  ["/en/podcast-video", "One recording day, a month of content", "en"],
  ["/en/press", "What we publish, and where we get covered", "en"],
  ["/en/press/commercial-2026-report", "Fenny releases the 2026 Nordic commercial video", "en"],
  ["/en/pricing", "No hours", "en"],
  ["/en/prime", "Larger productions that demand more", "en"],
  ["/en/privacy", "First-party, anonymous, no surveillance", "en"],
  ["/en/process", "Brief to broadcast in twenty-one days", "en"],
  ["/en/product-video", "Show what it does", "en"],
  ["/en/pulse", "Video on subscription", "en"],
  ["/en/pulse-vs-prime", "Pulse or Prime", "en"],
  ["/en/questions", "Straight answers about video", "en"],
  ["/en/questions/commercial-cost", "How much does a commercial cost", "en"],
  ["/en/questions/corporate-video-cost", "How much does a corporate video cost", "en"],
  ["/en/questions/difference-life-story-memoir", "What is the difference between a filmed life story", "en"],
  ["/en/questions/employer-branding-cost", "How much does an employer branding video cost", "en"],
  ["/en/questions/fenny-vs-agency", "How is Fenny different from a traditional video", "en"],
  ["/en/questions/film-agency-vs-video-agency", "What&#x27;s the difference between a film agency", "en"],
  ["/en/questions/how-does-filmed-knowledge-transfer-work", "How does filmed knowledge transfer work", "en"],
  ["/en/questions/how-long-does-a-filmed-life-story-take", "How long does a filmed life story take to produce", "en"],
  ["/en/questions/how-prime-works", "How does Fenny Prime work", "en"],
  ["/en/questions/how-pulse-works", "How does Fenny Pulse work", "en"],
  ["/en/questions/how-to-order-video", "How do you order a video step by step", "en"],
  ["/en/questions/how-to-write-a-video-script", "How do you write a good script for a corporate video", "en"],
  ["/en/questions/image-film-cost", "How much does an image film cost", "en"],
  ["/en/questions/motion-graphics-vs-animation", "What&#x27;s the difference between motion graphics", "en"],
  ["/en/questions/pulse-vs-prime", "What is the difference between Pulse and Prime", "en"],
  ["/en/questions/social-media-video-formats", "Which video formats work best on social media", "en"],
  ["/en/questions/subscription-vs-agency", "Video subscription vs traditional video agency", "en"],
  ["/en/questions/video-production-as-a-subscription", "What is video production as a subscription", "en"],
  ["/en/questions/video-production-cost", "How much does video production cost", "en"],
  ["/en/questions/video-production-time", "How long does a video production take", "en"],
  ["/en/questions/what-does-a-filmed-life-story-cost", "What does a filmed life story cost", "en"],
  ["/en/questions/what-is-fenny", "What is Fenny", "en"],
  ["/en/questions/what-is-fenny-heritage", "What is Fenny Heritage", "en"],
  ["/en/questions/what-is-internal-comms-video", "What is an internal communications video", "en"],
  ["/en/questions/what-is-video-subscription", "What is a video subscription", "en"],
  ["/en/questions/who-is-heritage-for", "Who is Fenny Heritage for", "en"],
  ["/en/questions/youtube-seo-for-video", "How do you optimise a video so it gets found on", "en"],
  ["/en/recruitment-video", "Hire faster with film that pre-qualifies", "en"],
  ["/en/reports/commercial-2026", "The Nordic commercial video report 2026", "en"],
  ["/en/services", "Video as a service", "en"],
  ["/en/social-media-video", "Every channel, one production cycle", "en"],
  ["/en/subscription-video", "Continuous output", "en"],
  ["/en/subscription-vs-project", "Subscription or project", "en"],
  ["/en/testimonial-video", "Social proof, on tap", "en"],
  ["/en/training-video", "Onboard at scale without losing the human touch", "en"],
  ["/en/video-agency", "Your always-on video partner", "en"],
  ["/en/video-agency-stockholm", "Video agency in Stockholm", "en"],
  ["/en/video-for-b2b", "B2B video that drives pipeline, not vanity views", "en"],
  ["/en/video-for-growth-companies", "Film that scales with the business", "en"],
  ["/en/video-for-instagram", "Built for Reels, scored for the algorithm", "en"],
  ["/en/video-for-linkedin", "B2B video the feed actually rewards", "en"],
  ["/en/video-for-marketing-teams", "A continuous film flow against your content calendar", "en"],
  ["/en/video-for-sales-teams", "Film that shortens the sales cycle", "en"],
  ["/en/video-for-tiktok", "Made for the For You page, not the brand book", "en"],
  ["/en/video-for-youtube", "Built for the watch-time graph, not just the", "en"],
  ["/en/video-price-calculator", "Estimate your video budget in minutes", "en"],
  ["/en/video-production", "Video production built for the way brands actually", "en"],
  ["/en/video-subscription", "Monthly video", "en"],
  ["/en/what-does-a-commercial-cost", "What does a commercial actually cost", "en"],
  ["/en/what-does-a-corporate-video-cost", "What does a corporate video cost", "en"],
  ["/en/why-video", "If you only fund one channel in 2026, fund this one", "en"],
  ["/en/work", "Video that moves real business metrics", "en"],
  ["/eventfilm", "Eventfilm som lever längre än kvällen", "lokalt"],
  ["/eventfilm/goteborg", "Eventfilm i Göteborg", "lokalt"],
  ["/eventfilm/malmo", "Eventfilm i Malmö", "lokalt"],
  ["/eventfilm/stockholm", "Eventfilm i Stockholm", "lokalt"],
  ["/explainer-video", "Explainer-video som förklarar", "tjanster"],
  ["/faq", "Svar på allt ni brukar undra", "tjanster"],
  ["/film-for-instagram", "Film för Instagram som funkar i algoritmen 2026", "tjanster"],
  ["/film-for-linkedin", "Film för LinkedIn", "tjanster"],
  ["/film-for-tiktok", "Film för TikTok", "tjanster"],
  ["/film-for-youtube", "Film för YouTube", "tjanster"],
  ["/film-pris-kalkyl", "Vad styr priset på en filmproduktion", "pris"],
  ["/filmbolag", "Filmbolag för uppdragsfilm", "lokalt"],
  ["/filmbyra", "Filmbyrån som driver hela kedjan", "lokalt"],
  ["/filmproducent", "En dedikerad filmproducent", "tjanster"],
  ["/filmproduktion", "Filmproduktion utan byråspråk och utan månader av", "lokalt"],
  ["/filmproduktion-dalarna", "Filmproduktion i Dalarna och Värmland", "lokalt"],
  ["/filmproduktion-mellansverige", "Filmproduktion i Mellansverige", "lokalt"],
  ["/filmproduktion-norrland", "Filmproduktion i Norrland", "lokalt"],
  ["/filmproduktion-ostergotland", "Filmproduktion i Östergötland", "lokalt"],
  ["/filmproduktion-skane", "Filmproduktion i Skåne", "lokalt"],
  ["/filmproduktion-smaland", "Filmproduktion i Småland", "lokalt"],
  ["/filmproduktion-sverige", "Filmproduktion i hela Sverige", "lokalt"],
  ["/filmproduktion-vastsverige", "Filmproduktion i Västsverige", "lokalt"],
  ["/filmproduktion/boras", "Filmproduktion i Borås", "lokalt"],
  ["/filmproduktion/borlange", "Filmproduktion i Borlänge", "lokalt"],
  ["/filmproduktion/eskilstuna", "Filmproduktion i Eskilstuna", "lokalt"],
  ["/filmproduktion/falun", "Filmproduktion i Falun", "lokalt"],
  ["/filmproduktion/gavle", "Filmproduktion i Gävle", "lokalt"],
  ["/filmproduktion/goteborg", "Filmproduktion i Göteborg", "lokalt"],
  ["/filmproduktion/halmstad", "Filmproduktion i Halmstad", "lokalt"],
  ["/filmproduktion/helsingborg", "Filmproduktion i Helsingborg", "lokalt"],
  ["/filmproduktion/hisingen", "Filmproduktion i Hisingen", "lokalt"],
  ["/filmproduktion/hyllie", "Filmproduktion i Hyllie", "lokalt"],
  ["/filmproduktion/jonkoping", "Filmproduktion i Jönköping", "lokalt"],
  ["/filmproduktion/kalmar", "Filmproduktion i Kalmar", "lokalt"],
  ["/filmproduktion/karlskrona", "Filmproduktion i Karlskrona", "lokalt"],
  ["/filmproduktion/karlstad", "Filmproduktion i Karlstad", "lokalt"],
  ["/filmproduktion/kista", "Filmproduktion i Kista", "lokalt"],
  ["/filmproduktion/kristianstad", "Filmproduktion i Kristianstad", "lokalt"],
  ["/filmproduktion/lindholmen", "Filmproduktion i Lindholmen", "lokalt"],
  ["/filmproduktion/linkoping", "Filmproduktion i Linköping", "lokalt"],
  ["/filmproduktion/lulea", "Filmproduktion i Luleå", "lokalt"],
  ["/filmproduktion/lund", "Filmproduktion i Lund", "lokalt"],
  ["/filmproduktion/malmo", "Filmproduktion i Malmö", "lokalt"],
  ["/filmproduktion/molndal", "Filmproduktion i Mölndal", "lokalt"],
  ["/filmproduktion/nacka", "Filmproduktion i Nacka", "lokalt"],
  ["/filmproduktion/norrkoping", "Filmproduktion i Norrköping", "lokalt"],
  ["/filmproduktion/nykoping", "Filmproduktion i Nyköping", "lokalt"],
  ["/filmproduktion/orebro", "Filmproduktion i Örebro", "lokalt"],
  ["/filmproduktion/ostersund", "Filmproduktion i Östersund", "lokalt"],
  ["/filmproduktion/skelleftea", "Filmproduktion i Skellefteå", "lokalt"],
  ["/filmproduktion/skovde", "Filmproduktion i Skövde", "lokalt"],
  ["/filmproduktion/sodermalm", "Filmproduktion i Södermalm", "lokalt"],
  ["/filmproduktion/sodertalje", "Filmproduktion i Södertälje", "lokalt"],
  ["/filmproduktion/solna", "Filmproduktion i Solna", "lokalt"],
  ["/filmproduktion/stockholm", "Filmproduktion i Stockholm", "lokalt"],
  ["/filmproduktion/sundbyberg", "Filmproduktion i Sundbyberg", "lokalt"],
  ["/filmproduktion/sundsvall", "Filmproduktion i Sundsvall", "lokalt"],
  ["/filmproduktion/taby", "Filmproduktion i Täby", "lokalt"],
  ["/filmproduktion/trollhattan", "Filmproduktion i Trollhättan", "lokalt"],
  ["/filmproduktion/uddevalla", "Filmproduktion i Uddevalla", "lokalt"],
  ["/filmproduktion/umea", "Filmproduktion i Umeå", "lokalt"],
  ["/filmproduktion/uppsala", "Filmproduktion i Uppsala", "lokalt"],
  ["/filmproduktion/varberg", "Filmproduktion i Varberg", "lokalt"],
  ["/filmproduktion/vasteras", "Filmproduktion i Västerås", "lokalt"],
  ["/filmproduktion/vaxjo", "Filmproduktion i Växjö", "lokalt"],
  ["/filmproduktion/visby", "Filmproduktion i Visby", "lokalt"],
  ["/filmproduktionsbolag", "Ett filmproduktionsbolag som levererar på datum", "lokalt"],
  ["/for-journalister", "Behöver du en källa om svensk reklamfilm", "tjanster"],
  ["/for-vem", "Företag, privat & arv", "for-vem"],
  ["/for-vem/byraer", "White-label produktionspartner för era kunder", "for-vem"],
  ["/for-vem/forbund", "Berätta medlemsnyttan", "for-vem"],
  ["/for-vem/grundare", "Film som följer ert tempo", "for-vem"],
  ["/for-vem/marknadsteam", "Avlasta interna teamet och lansera kampanjer", "for-vem"],
  ["/for-vem/some-team", "Konstant flöde av klipp som presterar i feeden", "for-vem"],
  ["/foretagsfilm", "Företagsfilm som faktiskt blir sedd", "lokalt"],
  ["/foretagsfilm/halmstad", "Företagsfilm i Halmstad", "lokalt"],
  ["/formatguide-2026", "Formatguide 2026", "tjanster"],
  ["/forproduktion", "Allt som måste vara klart innan kameran rullar", "tjanster"],
  ["/foto", "Fotograf för företag", "foto"],
  ["/foto/bildbank", "En bildbank är inte en mapp", "foto"],
  ["/foto/boka-fotograf-stockholm", "Boka fotograf i Stockholm", "foto"],
  ["/foto/boras", "Fotograf Borås", "foto"],
  ["/foto/brollopsfotograf", "Bröllopsfotograf", "foto"],
  ["/foto/dronarfoto", "Flygbilder som förklarar hela anläggningen på en", "foto"],
  ["/foto/eskilstuna", "Fotograf Eskilstuna", "foto"],
  ["/foto/eventfoto", "Eventbilder som går att publicera medan eventet", "foto"],
  ["/foto/eventfotograf-goteborg", "Eventfotograf i Göteborg", "foto"],
  ["/foto/eventfotograf-malmo", "Eventfotograf i Malmö", "foto"],
  ["/foto/eventfotograf-stockholm", "Eventfotograf i Stockholm", "foto"],
  ["/foto/foretagsfotograf", "En företagsfotograf som kan hela bildbehovet", "foto"],
  ["/foto/foretagsfotograf-goteborg", "Företagsfotograf i Göteborg", "foto"],
  ["/foto/foretagsfotograf-malmo", "Företagsfotograf i Malmö", "foto"],
  ["/foto/foretagsfotograf-stockholm", "Företagsfotograf i Stockholm", "foto"],
  ["/foto/foretagsfotografering", "Företagsfotografering som håller ihop hela", "foto"],
  ["/foto/foretagsportratt", "Porträtt som ser ut att höra ihop", "foto"],
  ["/foto/foretagsportratt-pris", "Vad kostar företagsporträtt", "foto"],
  ["/foto/foto-och-film", "En dag", "foto"],
  ["/foto/fotoagentur", "En fotoagentur i stället för fem frilansare", "foto"],
  ["/foto/fotostudio-stockholm", "Fotostudio i Stockholm", "foto"],
  ["/foto/galleri", "Hela portfolion", "foto"],
  ["/foto/gavle", "Fotograf Gävle", "foto"],
  ["/foto/goteborg", "Fotograf Göteborg", "foto"],
  ["/foto/halmstad", "Fotograf Halmstad", "foto"],
  ["/foto/headshots", "Headshots som ser ut som personen", "foto"],
  ["/foto/helsingborg", "Fotograf Helsingborg", "foto"],
  ["/foto/jamfor", "Frilansfotograf, fotoagentur eller abonnemang", "foto"],
  ["/foto/jonkoping", "Fotograf Jönköping", "foto"],
  ["/foto/kampanjfoto", "Kampanjbilder som bär ett budskap, inte bara en", "foto"],
  ["/foto/karlstad", "Fotograf Karlstad", "foto"],
  ["/foto/linkoping", "Fotograf Linköping", "foto"],
  ["/foto/lulea", "Fotograf Luleå", "foto"],
  ["/foto/lund", "Fotograf Lund", "foto"],
  ["/foto/malmo", "Fotograf Malmö", "foto"],
  ["/foto/norrkoping", "Fotograf Norrköping", "foto"],
  ["/foto/orebro", "Fotograf Örebro", "foto"],
  ["/foto/personalfoto", "Personalfoto där alla ser ut att jobba på samma", "foto"],
  ["/foto/portrattfotograf", "Porträttfotograf som får folk att se ut som sig", "foto"],
  ["/foto/portrattfotograf-goteborg", "Porträttfotograf i Göteborg", "foto"],
  ["/foto/portrattfotograf-malmo", "Porträttfotograf i Malmö", "foto"],
  ["/foto/portrattfotograf-stockholm", "Porträttfotograf i Stockholm", "foto"],
  ["/foto/produktfoto", "Produktbilder som säljer i flödet", "foto"],
  ["/foto/produktfoto-pris", "Vad kostar produktfotografering", "foto"],
  ["/foto/produktfotograf-goteborg", "Produktfotograf i Göteborg", "foto"],
  ["/foto/produktfotograf-malmo", "Produktfotograf i Malmö", "foto"],
  ["/foto/produktfotograf-stockholm", "Produktfotograf i Stockholm", "foto"],
  ["/foto/reklamfotograf", "Reklamfotograf som börjar i formatet, inte i kameran", "foto"],
  ["/foto/retusch", "Retusch", "foto"],
  ["/foto/stockholm", "Fotograf Stockholm", "foto"],
  ["/foto/studiofotografering", "Studio", "foto"],
  ["/foto/sundsvall", "Fotograf Sundsvall", "foto"],
  ["/foto/umea", "Fotograf Umeå", "foto"],
  ["/foto/uppsala", "Fotograf Uppsala", "foto"],
  ["/foto/vad-kostar-en-fotograf", "Vad kostar en fotograf", "foto"],
  ["/foto/vasteras", "Fotograf Västerås", "foto"],
  ["/foto/vaxjo", "Fotograf Växjö", "foto"],
  ["/fragor", "Raka svar om film", "fragor"],
  ["/fragor/anvander-filmbranschen-ai", "Hur mycket AI används i svensk filmproduktion 2026", "fragor"],
  ["/fragor/ar-film-pa-abonnemang-battre-an-projektpris", "Är film på abonnemang bättre än projektpris", "fragor"],
  ["/fragor/bildindex-leveranstid-bilder", "Hur lång tid tar det att få bilderna efter en", "fragor"],
  ["/fragor/bildindex-pris-fotografering-2026", "Vad kostar fotografering i Sverige 2026", "fragor"],
  ["/fragor/brollopsfotograf-foto-och-film", "Kan man boka bröllopsfotograf och bröllopsfilm", "fragor"],
  ["/fragor/bygga-bildbank", "Hur bygger man en bildbank för ett företag", "fragor"],
  ["/fragor/dolda-kostnader-filmproduktion", "Vilka dolda kostnader kan tillkomma i en", "fragor"],
  ["/fragor/dronarfoto-regler", "Vad gäller för drönarfoto i Sverige", "fragor"],
  ["/fragor/faktura-betalning-film", "Hur fungerar betalning och fakturering för", "fragor"],
  ["/fragor/far-jag-citera-fennys-prisindex", "Får jag citera Fennys prisindex och branschdata", "fragor"],
  ["/fragor/filmproduktion-goteborg-pris", "Vad kostar filmproduktion i Göteborg 2026", "fragor"],
  ["/fragor/filmproduktion-stockholm-pris", "Vad kostar filmproduktion i Stockholm 2026", "fragor"],
  ["/fragor/foretagsportratt-upplagg", "Hur går en fotografering av företagsporträtt till", "fragor"],
  ["/fragor/foto-och-film-samma-dag", "Kan man göra foto och film samma dag", "fragor"],
  ["/fragor/fotoagentur-eller-frilans", "Ska vi anlita frilansfotograf eller fotoagentur", "fragor"],
  ["/fragor/fotostudio-stockholm", "Vad ingår i en fotostudio i Stockholm", "fragor"],
  ["/fragor/generationsskifte-gard-skogsfastighet", "Hur gör man ett generationsskifte på gård eller", "fragor"],
  ["/fragor/hur-anvanda-film-industri", "Hur använder industriföretag film", "fragor"],
  ["/fragor/hur-anvanda-video-b2b", "Hur använder man video i B2B-marknadsföring", "fragor"],
  ["/fragor/hur-bestaller-man-film", "Hur beställer man en film steg för steg", "fragor"],
  ["/fragor/hur-bevara-livsberattelse", "Hur bevarar man en livsberättelse", "fragor"],
  ["/fragor/hur-dokumentera-foralders-livsberattelse", "Hur dokumenterar man en förälders livsberättelse", "fragor"],
  ["/fragor/hur-dokumentera-foretagshistoria", "Hur dokumenterar man företagshistoria", "fragor"],
  ["/fragor/hur-dokumentera-kunskap-generationsskifte", "Hur dokumenterar man kunskap vid ett", "fragor"],
  ["/fragor/hur-dokumentera-tyst-kunskap", "Hur dokumenterar företag tyst kunskap", "fragor"],
  ["/fragor/hur-fraga-foralder-om-livsberattelse", "Hur frågar man en förälder om att spela in en", "fragor"],
  ["/fragor/hur-fungerar-fenny-flow", "Hur fungerar Fenny Flow", "fragor"],
  ["/fragor/hur-fungerar-fenny-prime", "Hur fungerar Fenny Prime", "fragor"],
  ["/fragor/hur-fungerar-fenny-pulse", "Hur fungerar Fenny Pulse", "fragor"],
  ["/fragor/hur-fungerar-videoabonnemang", "Hur fungerar ett videoabonnemang", "fragor"],
  ["/fragor/hur-gor-man-bra-manus-foretagsfilm", "Hur skriver man ett bra manus till en företagsfilm", "fragor"],
  ["/fragor/hur-gor-man-en-bra-linkedin-video", "Hur gör man en bra LinkedIn-video", "fragor"],
  ["/fragor/hur-gor-man-kompetensinventering", "Hur gör man en kompetensinventering", "fragor"],
  ["/fragor/hur-gor-man-kunskapsoverforing-pa-film", "Hur fungerar kunskapsöverföring på film", "fragor"],
  ["/fragor/hur-gora-film-av-slakthistoria", "Hur gör man film av sin släkthistoria", "fragor"],
  ["/fragor/hur-lang-reklamfilm", "Hur lång ska en reklamfilm vara", "fragor"],
  ["/fragor/hur-lang-ska-foretagsfilm-vara", "Hur lång ska en företagsfilm vara", "fragor"],
  ["/fragor/hur-lang-tid-tar-filmproduktion", "Hur lång tid tar en filmproduktion", "fragor"],
  ["/fragor/hur-lang-tid-tar-livsberattelse", "Hur lång tid tar det att göra en livsberättelse på", "fragor"],
  ["/fragor/hur-langt-fore-pension-kunskapsoverforing", "Hur långt före pensionen bör kunskapsöverföringen", "fragor"],
  ["/fragor/hur-manga-ord-per-minut-film", "Hur många ord speakertext går det på en minut film", "fragor"],
  ["/fragor/hur-marker-man-film-for-youtube", "Hur märker man film för YouTube så att den hittas", "fragor"],
  ["/fragor/hur-ofta-bor-foretag-publicera-video", "Hur ofta bör företag publicera video", "fragor"],
  ["/fragor/hur-ofta-publicera-linkedin-video", "Hur ofta bör ett B2B-företag publicera video på", "fragor"],
  ["/fragor/hur-overfora-kunskap-pension", "Hur överför man kunskap när någon går i pension", "fragor"],
  ["/fragor/hur-skriver-man-ett-filmmanus", "Hur skriver man ett bra filmmanus för en", "fragor"],
  ["/fragor/hur-snabbt-leverans-pulse", "Hur snabbt får jag första videon med Pulse", "fragor"],
  ["/fragor/hur-snabbt-producerar-fenny", "Hur snabbt kan Fenny producera film", "fragor"],
  ["/fragor/hur-spela-in-livsberattelse-sjalv", "Hur spelar man in en livsberättelse själv", "fragor"],
  ["/fragor/hur-stor-ar-en-filmbudget", "Hur stor filmbudget har svenska företag 2026", "fragor"],
  ["/fragor/hur-stor-budget-marknadsavdelning-video", "Hur stor del av marknadsbudgeten bör läggas på", "fragor"],
  ["/fragor/kan-jag-pausa-pulse", "Kan jag pausa eller säga upp mitt filmabonnemang", "fragor"],
  ["/fragor/nar-ska-generationsskifte-dokumenteras", "När i ett generationsskifte bör kunskapen", "fragor"],
  ["/fragor/personalfoto-upplagg", "Hur går personalfotografering till", "fragor"],
  ["/fragor/praktik-filmproduktion", "Hur får man praktik inom filmproduktion", "fragor"],
  ["/fragor/pulse-vs-prime-val", "Ska jag välja Pulse eller Prime", "fragor"],
  ["/fragor/retuschnivaer", "Vilka retuschnivåer finns och vad ingår i priset", "fragor"],
  ["/fragor/ska-man-anlita-filmbyra-eller-bygga-inhouse", "Ska man anlita filmbyrå eller bygga inhouse", "fragor"],
  ["/fragor/skillnad-filmbolag-filmbyra", "Vad är skillnaden mellan ett filmbolag och en", "fragor"],
  ["/fragor/skillnad-livsberattelse-memoarbok", "Vad är skillnaden mellan en livsberättelse på film", "fragor"],
  ["/fragor/skillnad-manus-storyboard", "Vad är skillnaden mellan manus och storyboard", "fragor"],
  ["/fragor/skillnaden-fenny-filmbyra", "Vad är skillnaden mellan Fenny och en traditionell", "fragor"],
  ["/fragor/skillnaden-filmbyra-videobyra", "Vad är skillnaden mellan en filmbyrå och en", "fragor"],
  ["/fragor/skillnaden-motion-graphics-animation", "Vad är skillnaden mellan motion graphics och", "fragor"],
  ["/fragor/skillnaden-pulse-prime", "Vad är skillnaden mellan Pulse och Prime", "fragor"],
  ["/fragor/vad-ar-b-roll", "Vad är B-roll", "fragor"],
  ["/fragor/vad-ar-employer-branding-film", "Vad är employer branding-film", "fragor"],
  ["/fragor/vad-ar-en-internkommunikationsfilm", "Vad är en internkommunikationsfilm", "fragor"],
  ["/fragor/vad-ar-en-kundcasefilm", "Vad är en kundcasefilm", "fragor"],
  ["/fragor/vad-ar-fenny", "Vad är Fenny", "fragor"],
  ["/fragor/vad-ar-fenny-heritage", "Vad är Fenny Heritage", "fragor"],
  ["/fragor/vad-ar-film-pa-abonnemang", "Vad är film på abonnemang", "fragor"],
  ["/fragor/vad-ar-filmad-livsberattelse", "Vad är en filmad livsberättelse", "fragor"],
  ["/fragor/vad-ar-green-screen-studio", "Vad är en green screen studio", "fragor"],
  ["/fragor/vad-ar-hook-rate", "Vad är hook rate", "fragor"],
  ["/fragor/vad-ar-intern-aktieoverlatelse", "Vad är en intern aktieöverlåtelse", "fragor"],
  ["/fragor/vad-ar-kompetensinventering", "Vad är en kompetensinventering", "fragor"],
  ["/fragor/vad-ar-konceptutveckling-film", "Vad är konceptutveckling för film", "fragor"],
  ["/fragor/vad-ar-kunskapsarv", "Vad är kunskapsarv", "fragor"],
  ["/fragor/vad-ar-minnesfilm", "Vad är en minnesfilm", "fragor"],
  ["/fragor/vad-ar-reklamfilm", "Vad är en reklamfilm", "fragor"],
  ["/fragor/vad-ar-successionsplanering", "Vad är successionsplanering", "fragor"],
  ["/fragor/vad-ar-tyst-kunskap", "Vad är tyst kunskap", "fragor"],
  ["/fragor/vad-ar-video-as-a-service", "Vad är Video as a Service", "fragor"],
  ["/fragor/vad-gor-en-linjeproducent", "Vad gör en linjeproducent", "fragor"],
  ["/fragor/vad-gor-en-portrattfotograf", "Vad gör en porträttfotograf och vad kostar det", "fragor"],
  ["/fragor/vad-gor-en-reklamfotograf", "Vad gör en reklamfotograf", "fragor"],
  ["/fragor/vad-ingar-i-filmabonnemang", "Vad ingår i ett filmabonnemang", "fragor"],
  ["/fragor/vad-ingar-i-forproduktion", "Vad ingår i förproduktion av film", "fragor"],
  ["/fragor/vad-kostar-30-sek-reklamfilm", "Vad kostar en 30-sekunders reklamfilm 2026", "fragor"],
  ["/fragor/vad-kostar-dronarfilm", "Vad kostar en drönarfilm 2026", "fragor"],
  ["/fragor/vad-kostar-employer-branding-film", "Vad kostar en employer branding-film", "fragor"],
  ["/fragor/vad-kostar-en-foretagsfotograf", "Vad kostar en företagsfotograf", "fragor"],
  ["/fragor/vad-kostar-en-imagefilm", "Vad kostar en imagefilm", "fragor"],
  ["/fragor/vad-kostar-en-livesandning", "Vad kostar en livesändning", "fragor"],
  ["/fragor/vad-kostar-en-videopodcast", "Vad kostar en videopodcast", "fragor"],
  ["/fragor/vad-kostar-ett-headshot", "Vad kostar ett professionellt headshot", "fragor"],
  ["/fragor/vad-kostar-ett-manus", "Vad kostar ett manus till reklamfilm", "fragor"],
  ["/fragor/vad-kostar-eventfilm", "Vad kostar eventfilm", "fragor"],
  ["/fragor/vad-kostar-explainer-video", "Vad kostar en explainer-video 2026", "fragor"],
  ["/fragor/vad-kostar-film-pa-abonnemang", "Vad kostar film på abonnemang 2026", "fragor"],
  ["/fragor/vad-kostar-filmproduktion", "Vad kostar filmproduktion", "fragor"],
  ["/fragor/vad-kostar-foretagshistoria-pa-film", "Vad kostar en företagshistoriefilm", "fragor"],
  ["/fragor/vad-kostar-foretagsportratt", "Vad kostar en porträttdag för företaget", "fragor"],
  ["/fragor/vad-kostar-green-screen", "Vad kostar en green screen-inspelning", "fragor"],
  ["/fragor/vad-kostar-linkedin-video", "Vad kostar en LinkedIn-video 2026", "fragor"],
  ["/fragor/vad-kostar-livsberattelse-pa-film", "Vad kostar en livsberättelse på film", "fragor"],
  ["/fragor/vad-kostar-minnesfilm", "Vad kostar en minnesfilm", "fragor"],
  ["/fragor/vad-kostar-produktfilm", "Vad kostar en produktfilm 2026", "fragor"],
  ["/fragor/vad-kostar-produktfotografering", "Vad kostar produktfotografering per artikel", "fragor"],
  ["/fragor/vad-kostar-tv-reklam", "Vad kostar en tv-reklam", "fragor"],
  ["/fragor/vad-kostar-videoproduktion", "Vad kostar videoproduktion", "fragor"],
  ["/fragor/vad-kostar-voice-over", "Vad kostar en voice-over på svenska", "fragor"],
  ["/fragor/varfor-lopande-film", "Varför ska företag jobba löpande med film", "fragor"],
  ["/fragor/varfor-racker-inte-skriftlig-kunskapsdokumentation", "Varför räcker inte skriftlig dokumentation för att", "fragor"],
  ["/fragor/vem-ager-bilderna", "Vem äger bilderna efter en fotografering", "fragor"],
  ["/fragor/vem-passar-heritage", "Vem passar Fenny Heritage för", "fragor"],
  ["/fragor/vilka-filmer-behover-ett-tillvaxtbolag", "Vilka filmer behöver ett tillväxtbolag", "fragor"],
  ["/fragor/vilka-filmformat-for-sociala-medier", "Vilka filmformat fungerar bäst på sociala medier", "fragor"],
  ["/fragor/vilka-foretag-passar-fenny", "Vilka företag passar Fenny för", "fragor"],
  ["/fragor/vilka-fragor-livsberattelseintervju", "Vilka frågor ska man ställa i en", "fragor"],
  ["/fragor/vilken-kamera-foretagsfilm", "Vilken kamera används för företagsfilm och", "fragor"],
  ["/green-screen", "Green screen", "tjanster"],
  ["/guider", "Verktyg vi skulle önskat själva", "guider"],
  ["/guider/brief-mall", "Brief som inte slösar tid", "guider"],
  ["/guider/formatguide-2026", "Formatguide 2026", "guider"],
  ["/guider/manadsvis-filmplan", "Månadsvis filmplan", "guider"],
  ["/guider/sociala-hooks-2026", "10 sociala hooks som funkar 2026", "guider"],
  ["/heritage", "Berättelser och kunskap som inte får gå förlorade", "heritage"],
  ["/heritage/foretagshistoria-pa-film", "Företagshistoria på film", "heritage"],
  ["/heritage/generationsskifte-dokumentation", "Dokumentation vid generationsskifte", "heritage"],
  ["/heritage/generationsskifte-lantbruk-skog", "Generationsskifte på gård, lantbruk och", "heritage"],
  ["/heritage/goteborg", "Livsberättelser och kunskapsarv i Göteborg", "heritage"],
  ["/heritage/helsingborg", "Livsberättelser och kunskapsarv i Helsingborg", "heritage"],
  ["/heritage/intervjufragor-livsberattelse", "Intervjufrågor för en livsberättelse", "heritage"],
  ["/heritage/jonkoping", "Livsberättelser och kunskapsarv i Jönköping", "heritage"],
  ["/heritage/kompetensinventering", "Kompetensinventering", "heritage"],
  ["/heritage/kunskapsarv", "Kunskapsarv", "heritage"],
  ["/heritage/linkoping", "Livsberättelser och kunskapsarv i Linköping", "heritage"],
  ["/heritage/livsberattelse-till-foralder", "Livsberättelse till förälder eller mor- och", "heritage"],
  ["/heritage/livsberattelser", "Filmade livsberättelser", "heritage"],
  ["/heritage/lund", "Livsberättelser och kunskapsarv i Lund", "heritage"],
  ["/heritage/malmo", "Livsberättelser och kunskapsarv i Malmö", "heritage"],
  ["/heritage/minnesfilm", "Minnesfilm", "heritage"],
  ["/heritage/norrkoping", "Livsberättelser och kunskapsarv i Norrköping", "heritage"],
  ["/heritage/orebro", "Livsberättelser och kunskapsarv i Örebro", "heritage"],
  ["/heritage/pensionsavgang-kunskapsoverforing", "Kunskapsöverföring inför pensionsavgång", "heritage"],
  ["/heritage/slakthistoria-pa-film", "Släkthistoria på film", "heritage"],
  ["/heritage/stockholm", "Livsberättelser och kunskapsarv i Stockholm", "heritage"],
  ["/heritage/successionsplanering-dokumentation", "Successionsplanering", "heritage"],
  ["/heritage/tyst-kunskap-dokumentation", "Dokumentera tyst kunskap", "heritage"],
  ["/heritage/umea", "Livsberättelser och kunskapsarv i Umeå", "heritage"],
  ["/heritage/uppsala", "Livsberättelser och kunskapsarv i Uppsala", "heritage"],
  ["/heritage/vasteras", "Livsberättelser och kunskapsarv i Västerås", "heritage"],
  ["/instruktionsfilm", "Instruktionsfilm som faktiskt minskar", "tjanster"],
  ["/internkommunikation-film", "Internfilm som faktiskt höjer engagemanget", "tjanster"],
  ["/jamfor/fenny-vs-andeox", "Fenny vs Andeox", "jamfor"],
  ["/jamfor/fenny-vs-brandfixers", "Fenny vs Brandfixers", "jamfor"],
  ["/jamfor/fenny-vs-colibri-content", "Fenny vs Colibri Content", "jamfor"],
  ["/jamfor/fenny-vs-filmbyran", "Fenny vs Filmbyrån", "jamfor"],
  ["/jamfor/fenny-vs-filmmakeriet", "Fenny vs Filmmakeriet", "jamfor"],
  ["/jamfor/fenny-vs-klara-fardiga-film", "Fenny vs Klara Färdiga Film", "jamfor"],
  ["/jamfor/fenny-vs-parable", "Fenny vs Parable", "jamfor"],
  ["/jamfor/fenny-vs-social-cut", "Fenny vs Social Cut", "jamfor"],
  ["/jamfor/fenny-vs-streamrocket", "Fenny vs Streamrocket", "jamfor"],
  ["/jamfor/fenny-vs-street-studios", "Fenny vs Street Studios", "jamfor"],
  ["/jamfor/film-pa-abonnemang-vs-filmbyra", "Film på abonnemang vs traditionell filmbyrå", "jamfor"],
  ["/jamfor/filmabonnemang-vs-projektfilm", "Filmabonnemang vs projektfilm", "jamfor"],
  ["/jamfor/filmbolag-vs-filmbyra", "Filmbolag vs filmbyrå", "jamfor"],
  ["/jamfor/filmbyra-vs-frilansare", "Filmbyrå vs frilansare", "jamfor"],
  ["/jamfor/filmproduktion-abonnemang-vs-projektpris", "Filmproduktion på abonnemang vs projektpris", "jamfor"],
  ["/jamfor/green-screen-vs-location", "Green screen vs inspelning på plats", "jamfor"],
  ["/jamfor/inhouse-vs-filmbyra", "Inhouse-filmteam eller filmbyrå", "jamfor"],
  ["/jamfor/kunskapsarv-internt-vs-extern-filmbyra", "Kunskapsarv internt vs med extern filmbyrå", "jamfor"],
  ["/jamfor/kunskapsoverforing-vs-process-dokumentation", "Kunskapsöverföring på film vs skriftlig", "jamfor"],
  ["/jamfor/livesandning-vs-inspelat-webinar", "Livesändning vs förinspelat webinar", "jamfor"],
  ["/jamfor/livsberattelse-pa-film-vs-ljudinspelning", "Livsberättelse på film vs ljudinspelning", "jamfor"],
  ["/jamfor/livsberattelse-pa-film-vs-memoarbok", "Livsberättelse på film vs memoarbok", "jamfor"],
  ["/jamfor/pulse-vs-prime", "Pulse vs Prime", "jamfor"],
  ["/jamfor/ramavtal-vs-direktupphandling-film", "Ramavtal vs direktupphandling av film", "jamfor"],
  ["/jamfor/video-as-a-service-vs-filmbyra", "Video as a Service vs traditionell filmbyrå", "jamfor"],
  ["/jamfor/videoabonnemang-vs-contentabonnemang", "Videoabonnemang vs contentabonnemang", "jamfor"],
  ["/jamfor/voice-over-vs-ai-rost", "Voice-over vs AI-röst", "jamfor"],
  ["/jobb", "Jobba med film hos Fenny", "tjanster"],
  ["/kampanjfilm", "Kampanjfilm som hänger ihop över alla kanaler", "tjanster"],
  ["/karriar", "Vi söker alltid talanger", "tjanster"],
  ["/konceptutveckling-film", "Ett koncept som bär mer än en film", "tjanster"],
  ["/kontakt", "Berätta vad ni behöver", "tjanster"],
  ["/kortformat-film", "Shorts som hookar i första 1,5 sekunden", "tjanster"],
  ["/kundcase-film", "Kundcase som faktiskt säljer", "tjanster"],
  ["/kunskap", "Vi skriver om det vi gör", "kunskap"],
  ["/kunskap/25-hooks-som-stannar-tummen", "25 hooks som faktiskt får folk att stanna", "kunskap"],
  ["/kunskap/3d-animation-vs-live-action-nar-valja-vad", "3D-animation vs live action", "kunskap"],
  ["/kunskap/ai-genererad-film-vs-traditionell", "AI-genererad film", "kunskap"],
  ["/kunskap/byggfilm-projektdokumentation-rekrytering", "Byggfilm", "kunskap"],
  ["/kunskap/det-kreativa-fundamentet", "Det kreativa fundamentet", "kunskap"],
  ["/kunskap/dronarfilm-regler-pris-nar-det-funkar", "Drönarfilm 2026", "kunskap"],
  ["/kunskap/e-handelsvideo-produktfilm-kampanj-ugc", "E-handelsvideo 2026", "kunskap"],
  ["/kunskap/fastighetsfilm-visningsvideo-varumarke-dronare", "Fastighetsfilm", "kunskap"],
  ["/kunskap/film-for-offentlig-sektor-upphandling-tonalitet", "Film för offentlig sektor", "kunskap"],
  ["/kunskap/filma-i-malardalen-vasteras-eskilstuna-solna", "Filma i Mälardalen", "kunskap"],
  ["/kunskap/filma-i-norrland-umea-sundsvall-lulea-gavle", "Filma i Norrland", "kunskap"],
  ["/kunskap/filma-i-skane-malmo-lund-helsingborg", "Filma i Skåne", "kunskap"],
  ["/kunskap/filma-i-smaland-vaxjo-jonkoping-halmstad", "Filma i Småland", "kunskap"],
  ["/kunskap/filmbyra-vs-frilansare-vs-inhouse", "Filmbyrå, frilansare eller inhouse", "kunskap"],
  ["/kunskap/filmproduktion-goteborg-guide-2026", "Filmproduktion i Göteborg", "kunskap"],
  ["/kunskap/filmproduktion-malmo-guide-2026", "Filmproduktion i Malmö", "kunskap"],
  ["/kunskap/filmproduktion-process-steg-for-steg", "Filmproduktion steg för steg", "kunskap"],
  ["/kunskap/filmproduktion-saas-bolag", "Filmproduktion för SaaS-företag", "kunskap"],
  ["/kunskap/filmproduktion-stockholm-guide-2026", "Filmproduktion i Stockholm", "kunskap"],
  ["/kunskap/foretagsfilm-i-ostergotland-linkoping-norrkoping", "Företagsfilm i Östergötland", "kunskap"],
  ["/kunskap/formatguide-2025", "Komplett formatguide 2025", "kunskap"],
  ["/kunskap/fran-film-till-effekt", "Från film till effekt", "kunskap"],
  ["/kunskap/hitta-ratt-filmbyra-stockholm-checklista", "Hitta rätt filmbyrå i Stockholm", "kunskap"],
  ["/kunskap/hur-lang-ska-en-film-vara", "Hur lång ska en film vara", "kunskap"],
  ["/kunskap/industrifilm-fabrik-process-tunga-maskiner", "Industrifilm", "kunskap"],
  ["/kunskap/instagram-reels-strategi-foretag-2026", "Instagram Reels-strategi för företag 2026", "kunskap"],
  ["/kunskap/linkedin-film-b2b-strategi-2026", "LinkedIn-film 2026", "kunskap"],
  ["/kunskap/psykologin-bakom-klicket", "Psykologin bakom klicket", "kunskap"],
  ["/kunskap/reklamfilm-i-mellansverige-uppsala-orebro-karlstad", "Reklamfilm i Mellansverige", "kunskap"],
  ["/kunskap/restaurangfilm-meny-atmosfar-sociala-medier", "Restaurangfilm", "kunskap"],
  ["/kunskap/skillnad-reklamfilm-foretagsfilm", "Skillnaden mellan reklamfilm och företagsfilm", "kunskap"],
  ["/kunskap/studio-vs-location-inspelning", "Studio eller location", "kunskap"],
  ["/kunskap/tiktok-svenska-varumarken-2026", "TikTok för svenska varumärken", "kunskap"],
  ["/kunskap/ugc-vs-producerad-film", "UGC vs producerad film", "kunskap"],
  ["/kunskap/vad-ar-ctr-video", "CTR på videoannonser", "kunskap"],
  ["/kunskap/vad-ar-employer-branding-film", "Vad är en employer branding-film", "kunskap"],
  ["/kunskap/vad-ar-en-aftermovie", "Vad är en aftermovie", "kunskap"],
  ["/kunskap/vad-ar-en-explainer-video", "Vad är en explainer video", "kunskap"],
  ["/kunskap/vad-ar-en-foretagsfilm", "Vad är en företagsfilm", "kunskap"],
  ["/kunskap/vad-ar-en-hook-video", "Hook (video)", "kunskap"],
  ["/kunskap/vad-ar-en-instruktionsfilm", "Vad är en instruktionsfilm", "kunskap"],
  ["/kunskap/vad-ar-en-kampanjfilm", "Vad är en kampanjfilm", "kunskap"],
  ["/kunskap/vad-ar-en-massfilm", "Mässfilm", "kunskap"],
  ["/kunskap/vad-ar-en-pitchfilm", "Pitchfilm", "kunskap"],
  ["/kunskap/vad-ar-en-testimonial-film", "Vad är en testimonial-film", "kunskap"],
  ["/kunskap/vad-ar-motion-graphics", "Vad är motion graphics", "kunskap"],
  ["/kunskap/vad-ar-roas-video", "Vad är ROAS på video", "kunskap"],
  ["/kunskap/vad-kostar-en-foretagsfilm", "Vad kostar en företagsfilm 2026", "kunskap"],
  ["/kunskap/vad-kostar-en-reklamfilm", "Vad kostar en reklamfilm 2026", "kunskap"],
  ["/kunskap/vardfilm-patientinfo-employer-branding-halsa", "Vårdfilm", "kunskap"],
  ["/kunskap/video-kpi-komplett-guide", "Video-KPI:er 2026", "kunskap"],
  ["/kunskap/videolandskapet-2025", "Videolandskapet 2025", "kunskap"],
  ["/kunskap/youtube-foretag-long-form-shorts-kanaltillvaxt", "YouTube för företag", "kunskap"],
  ["/livesandning", "Livesändning där inget får gå fel", "tjanster"],
  ["/manus-och-koncept", "Filmen avgörs innan kameran rullar", "tjanster"],
  ["/manusforfattare", "Manusförfattare som också vet hur filmen spelas in", "tjanster"],
  ["/massfilm", "Mässfilm och monterfilm som stoppar folk i gången", "tjanster"],
  ["/mata-effekt-av-film", "Så mäter ni effekt av företagsfilm", "tjanster"],
  ["/motion-graphics", "Motion graphics där varje rörelse betyder något", "tjanster"],
  ["/om-fenny", "Vi gör film för människor", "tjanster"],
  ["/ordlista", "Filmbegrepp på svenska", "tjanster"],
  ["/ordlista/filmabonnemang", "Filmabonnemang", "tjanster"],
  ["/ordlista/premiumfilm-pa-abonnemang", "Premiumfilm på abonnemang", "tjanster"],
  ["/ordlista/pulse-modellen", "Pulse-modellen", "tjanster"],
  ["/partners", "Vi växer hellre med rätt partners än fler", "tjanster"],
  ["/pilot", "Testa oss med ett Pilot", "tjanster"],
  ["/podcast-video", "Videopodcast", "tjanster"],
  ["/praktik", "Praktik inom filmproduktion", "tjanster"],
  ["/press", "Press", "tjanster"],
  ["/press/reklamfilm-2026-rapport", "Fenny släpper Reklamfilmsrapporten 2026", "tjanster"],
  ["/prime", "Större produktioner som kräver mer", "prime"],
  ["/prime/film-streaming-tv", "Film, streaming & TV", "prime"],
  ["/prime/klipp-grade", "Klippning & gradering", "prime"],
  ["/prime/ljussattning", "Ljussättning & gaffer", "prime"],
  ["/prime/poddar", "Live- & studiopoddar", "prime"],
  ["/prime/post-produktion", "Post-produktion", "prime"],
  ["/prime/regi-manus", "Regi, manus & direction", "prime"],
  ["/prime/reklam-dokumentar", "Reklam & dokumentär", "prime"],
  ["/prime/studio-live-webinars", "Studio, live & webinars", "prime"],
  ["/pris", "Vad kostar film", "pris"],
  ["/pris/animerad-film", "Vad kostar en animerad film", "pris"],
  ["/pris/kunskapsoverforing", "Vad kostar kunskapsöverföring på film", "pris"],
  ["/pris/sociala-medier-film", "Vad kostar film för sociala medier", "pris"],
  ["/priser", "Inga timmar", "pris"],
  ["/process", "Från brief till löpande effekt", "tjanster"],
  ["/produktfilm", "Produktfilm som höjer konverteringen", "tjanster"],
  ["/produktionsbolag-film", "Produktionsbolag som tänker", "tjanster"],
  ["/pulse", "Film på abonnemang", "tjanster"],
  ["/rapport/reklamfilm-2026", "Reklamfilm i Sverige 2026", "tjanster"],
  ["/redaktionell-policy", "Redaktionell policy", "tjanster"],
  ["/redaktionen", "Redaktionen bakom Fennys innehåll", "tjanster"],
  ["/redaktionen/default", "Fenny-redaktionen", "tjanster"],
  ["/redaktionen/mattias", "Mattias Björk", "tjanster"],
  ["/reklamfilm", "Reklamfilm som faktiskt får folk att stanna", "lokalt"],
  ["/reklamfilm/goteborg", "Reklamfilm i Göteborg", "lokalt"],
  ["/reklamfilm/malmo", "Reklamfilm i Malmö", "lokalt"],
  ["/reklamfilm/stockholm", "Reklamfilm i Stockholm", "lokalt"],
  ["/reklamfilmsmanus", "Reklamfilmsmanus som håller i tre sekunder", "lokalt"],
  ["/rekryteringsfilm", "Rekryteringsfilm som drar rätt folk", "tjanster"],
  ["/sociala-medier-film", "Film för sociala medier", "tjanster"],
  ["/storyboard", "Storyboard", "tjanster"],
  ["/testimonial-film", "Era kunder säger det ni själva inte kan säga", "tjanster"],
  ["/tjanster", "Film som tjänst", "tjanster"],
  ["/tv-produktion", "Tv-produktion som klarar sändningskraven första", "tjanster"],
  ["/upphandling-film", "Upphandla filmproduktion utan att låsa in er i fel", "tjanster"],
  ["/utbildningsfilm", "Utbildningsfilm som folk faktiskt orkar titta klart", "tjanster"],
  ["/vad-kostar-en-reklamfilm", "Vad kostar en reklamfilm i Sverige 2026", "pris"],
  ["/vad-kostar-ett-manus", "Vad kostar ett manus till film 2026", "pris"],
  ["/varfor-film", "Film är inte en kanal", "tjanster"],
  ["/varumarkesfilm", "Varumärkesfilm som ger paid effekten ni inte trodde", "tjanster"],
  ["/videoproduktion", "Videoproduktion som tar er över algoritmens tröskel", "lokalt"],
  ["/videoproduktion-sverige", "Videoproduktion i hela Sverige", "lokalt"],
  ["/voice-over", "Voice over", "tjanster"],
];
